import React, { ReactNode, createContext, useContext, useState  } from 'react';
import { ConfigurableLineChartSettingsProps } from '../../ConfigurableLineChart.types';

export type ConfigurableLineChartSettingsReturnProps = [ConfigurableLineChartSettingsProps, (x?: Record<string, unknown>) => void, boolean];

export const useConfigurableLineChartSettings = (): ConfigurableLineChartSettingsReturnProps =>
  useContext(ConfigurableLineChartSettingsContext)

interface Props extends ConfigurableLineChartSettingsProps {
  children?: ReactNode;
  filterMinMaxData?: boolean;
}

const defaultSettings: ConfigurableLineChartSettingsProps = {
  filterSelectedData: undefined,
  timestampKey: undefined,
  valueKey: undefined,
  valueKeys: undefined,
  categoryKey: undefined,
  startTimeKey: undefined,
  endTimeKey: undefined,
  groupKey: undefined,
  zoomY: undefined,
  zoomX: undefined,
  domainLeft: undefined,
  domainRight: undefined,
  domainTop: undefined,
  domainBottom: undefined,
  autoFill: undefined,
  curve: undefined,
  chartType: undefined,
  ticks: undefined
}

export const ConfigurableLineChartSettingsProvider = ({ children,  ...settings   }: Props): JSX.Element => {

  const [customSettings, setSettingsToUse] = useState<ConfigurableLineChartSettingsProps | undefined>(settings);   

  return (
    <ConfigurableLineChartSettingsContext.Provider 
      value={ [
        customSettings as ConfigurableLineChartSettingsProps, 
        ((x?: ConfigurableLineChartSettingsProps) => {
          const newSettings = {...customSettings, ...x} as ConfigurableLineChartSettingsProps
          return setSettingsToUse(newSettings)
        }),
        // shows that settings havebeen initialized
        true
        ] }>
      {children}
    </ConfigurableLineChartSettingsContext.Provider>
  );
};

const ConfigurableLineChartSettingsContext = createContext<ConfigurableLineChartSettingsReturnProps>([
  {} as ConfigurableLineChartSettingsProps,
  (x?: ConfigurableLineChartSettingsProps | undefined) => console.log({x}, 'not used'),
  false
]);
